import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "mt-8" }
const _hoisted_3 = { class: "mt-2 border rounded" }
const _hoisted_4 = { class: "py-2 capitalize" }
const _hoisted_5 = { class: "py-2 capitalize" }
const _hoisted_6 = { class: "py-2 capitalize" }
const _hoisted_7 = { class: "mt-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "text-3xl font-medium" }, "Parent/Carer", -1)
const _hoisted_9 = { class: "mt-6" }
const _hoisted_10 = { class: "flex justify-between px-4 py-2" }
const _hoisted_11 = { class: "flex items-center space-x-4" }
const _hoisted_12 = { class: "mt-6" }
const _hoisted_13 = { class: "text-3xl font-medium capitalize" }
const _hoisted_14 = { class: "mt-6 border border-gray-300 divide-y divide-gray-300 rounded" }
const _hoisted_15 = { class: "w-full px-4 py-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", { class: "text-2xl font-medium" }, "Additional", -1)
const _hoisted_17 = { class: "mt-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", { class: "text-3xl font-medium" }, "Permissions", -1)
const _hoisted_19 = { class: "mt-4" }
const _hoisted_20 = { class: "space-x-3" }
const _hoisted_21 = {
  href: "https://playincluded.com/data",
  target: "_blank",
  class: "text-link"
}
const _hoisted_22 = { class: "mt-4 space-x-3" }
const _hoisted_23 = { class: "mt-6" }
const _hoisted_24 = { class: "flex items-center justify-between" }
const _hoisted_25 = { class: "text-3xl font-medium capitalize" }
const _hoisted_26 = {
  key: 0,
  class: "mt-6 border border-gray-300 divide-y divide-gray-300 rounded"
}
const _hoisted_27 = { class: "w-full" }
const _hoisted_28 = { class: "mx-2 my-2 text-sm" }
const _hoisted_29 = { class: "block capitalize" }
const _hoisted_30 = { class: "block capitalize" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "block" }
const _hoisted_33 = { class: "block" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_35 = {
  key: 0,
  class: "flex flex-wrap gap-4 py-6"
}

import { ref } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";

import ReadOnlyNote from "@/components/ReadOnlyNote.vue";
import RouterButton from "@/components/RouterButton.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import ExternalLink from "@/components/ExternalLink.vue";

import api from "@/api/api";
import { useUserStore } from "@/store";
import { Student, StudentNote } from "@/types";
import { getSurveyUrl } from "@/utils/survey";


export default /*#__PURE__*/_defineComponent({
  __name: 'MyChild',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const { user } = storeToRefs(useUserStore());

const student = ref({} as Student);
const notes = ref([] as StudentNote[]);

async function listStudentNotes() {
  notes.value = (await api.students.listParentStudentNotes(user.value.id, student.value.id)).data.notes;
}

student.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.students.getStudentByParent(user.value.id, route.params.member_id as string))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.student;
;(
  ([__temp,__restore] = _withAsyncContext(() => listStudentNotes())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('my-child')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ExternalLink, {
          href: _unref(getSurveyUrl)(_unref(user), student.value, student.value.clubs[0]),
          label: _ctx.$t('complete-background-survey'),
          type: "button"
        }, null, 8, ["href", "label"])
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ListRowItem, {
          title: _ctx.$t('first-name-initial')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_4, _toDisplayString(student.value.first_name), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(ListRowItem, {
          title: _ctx.$t('family-name-initial')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_5, _toDisplayString(student.value.last_name), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(ListRowItem, {
          title: _ctx.$t('middle-name-initial')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_6, _toDisplayString(student.value.middle_name), 1)
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(student.value.parents, (parent, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mt-6 border border-gray-400 rounded",
              key: index
            }, [
              _createVNode(ListRowItem, {
                title: `${_ctx.$t('parent-carer')} - ${_ctx.$t('name')}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(parent.first_name) + " " + _toDisplayString(parent.last_name), 1)
                ]),
                _: 2
              }, 1032, ["title"]),
              _createVNode(ListRowItem, {
                title: `${_ctx.$t('parent-carer')} - ${_ctx.$t('email')}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(parent.email), 1)
                ]),
                _: 2
              }, 1032, ["title"]),
              _createVNode(ListRowItem, {
                title: `${_ctx.$t('parent-carer')} - ${_ctx.$t('added')}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(new Date(parent.meta!.pivot_created_at).toDateString()), 1)
                ]),
                _: 2
              }, 1032, ["title"]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", null, _toDisplayString(parent.id === student.value.primary_parent ? "Primary Carer" : ""), 1)
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("h2", _hoisted_13, _toDisplayString(_ctx.$t("background-notes")), 1),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(ReadOnlyNote, {
              content: student.value.additional_notes
            }, null, 8, ["content"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              class: "rounded",
              disabled: "",
              type: "radio",
              value: true,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((student.value.survey_permission) = $event))
            }, null, 512), [
              [_vModelRadio, student.value.survey_permission]
            ]),
            _createElementVNode("label", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("parent-onboarding-attendance-permission")) + " ", 1),
              _createElementVNode("a", _hoisted_21, _toDisplayString(_ctx.$t("what-does-this-mean")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              class: "rounded",
              disabled: "",
              type: "radio",
              value: false,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((student.value.survey_permission) = $event))
            }, null, 512), [
              [_vModelRadio, student.value.survey_permission]
            ]),
            _createElementVNode("label", null, _toDisplayString(_ctx.$t("parent-onboarding-no-permission")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("h2", _hoisted_25, _toDisplayString(_ctx.$t("brick-club-notes")), 1)
        ]),
        (notes.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notes.value, (note) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex flex-wrap justify-between w-full px-4 py-2 md:flex-nowrap",
                  key: note.id
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("span", _hoisted_29, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("facilitator")) + ":", 1),
                        _createTextVNode(" " + _toDisplayString(note.user.first_name) + " " + _toDisplayString(note.user.last_name), 1)
                      ]),
                      _createElementVNode("span", _hoisted_30, [
                        (note.session.brick_club)
                          ? (_openBlock(), _createElementBlock("strong", _hoisted_31, _toDisplayString(_ctx.$t("brick-club")) + ":", 1))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(note.session.brick_club?.name), 1)
                      ]),
                      _createElementVNode("span", _hoisted_32, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("session")) + ":", 1),
                        _createTextVNode(" " + _toDisplayString(new Date(note.session.date).toLocaleDateString()), 1)
                      ]),
                      _createElementVNode("span", _hoisted_33, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("visible-to-member-parent-carer")) + ":", 1),
                        _createTextVNode(" " + _toDisplayString(note.show_parent ? "Yes" : "No"), 1)
                      ]),
                      _createElementVNode("span", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("created")) + ":", 1),
                        _createTextVNode(" " + _toDisplayString(new Date(note.created_at).toLocaleString()), 1)
                      ])
                    ]),
                    _hoisted_34,
                    _createVNode(ReadOnlyNote, {
                      content: note.content
                    }, null, 8, ["content"])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (_unref(user).id === student.value.primary_parent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createVNode(RouterButton, {
              type: "primary",
              to: { name: 'Edit_Child', params: { student_id: student.value.id } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("edit-child")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})